import { schema } from "normalizr";
export const apiKey = 'api';
export const feesKey = 'fees';
export const feeEntity = new schema.Entity(feesKey);
export const facilitiesKey = 'facilities';
export const facilityEntity = new schema.Entity(facilitiesKey, {}, { idAttribute: 'uid' });
export const surveyQuestionsKey = 'survey_questions';
export const surveyQuestionEntity = new schema.Entity(surveyQuestionsKey);
export const accessDevicesKey = 'access_devices';
export const accessDeviceEntity = new schema.Entity(accessDevicesKey, {
    fee: feeEntity
});
export const billingProfileKey = 'billing_profiles';
export const billingProfileEntity = new schema.Entity(billingProfileKey)
export const ratesKey = 'rates';
export const rateEntity = new schema.Entity(ratesKey, {
    current_fees: [feeEntity],
    billing_profile: billingProfileEntity,
    access_devices: [accessDeviceEntity],
});
billingProfileEntity.define({
    rates: [rateEntity],
    survey_questions: [surveyQuestionEntity],
    facility: facilityEntity
})
export const purchaseKey = 'purchase';

export const entityTypes = {
    [ratesKey]: rateEntity,
    [feesKey]: feeEntity,
    [facilitiesKey]: facilityEntity,
    [surveyQuestionsKey]: surveyQuestionEntity,
    [accessDevicesKey]: accessDeviceEntity,
    [billingProfileKey]: billingProfileEntity
}
